import loadable from '@loadable/component';

export const ItproSiteWrapper = loadable(
  () => import(/* webpackChunkName: "itpro-site" */ './ItproSiteWrapper'),
);
